var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.69 56.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d6d4d4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.48,21.13a4.11,4.11,0,0,0-3.26-2.76L38.47,16.11,32.05,2.37a4.08,4.08,0,0,0-7.41,0L18.23,16.11,3.48,18.37a4.11,4.11,0,0,0-2.31,6.94L12,36.46,9.47,51.91a4.1,4.1,0,0,0,6,4.27L28.35,49l12.86,7.15a4.09,4.09,0,0,0,6-4.27L44.72,36.46,55.53,25.31a4.12,4.12,0,0,0,.95-4.18M41.79,33.58a4.13,4.13,0,0,0-1.11,3.54l2.51,15.45L30.33,45.43a4.1,4.1,0,0,0-4,0L13.51,52.57,16,37.12a4.13,4.13,0,0,0-1.11-3.54L4.09,22.44l14.76-2.27a4.06,4.06,0,0,0,3.08-2.31L28.35,4.12l6.41,13.74a4.08,4.08,0,0,0,3.09,2.31L52.6,22.44Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.3b96f530bb38524da31cb40813ea4afd.svg";
export { ForwardRef as ReactComponent };